import { IsArray, IsNumber, IsOptional, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

import { Reaction } from '../reaction';
import { ReferencePatent } from './reference-patent';

export class Reference {
  @ValidateNested()
  reaction!: Reaction;

  @IsArray()
  @ValidateNested()
  @Type(() => ReferencePatent)
  patents!: ReferencePatent[];

  @IsNumber()
  @IsOptional()
  yield?: number;
}
